import { ErrorHandler } from '@angular/core';
import * as LogRocket from 'logrocket';
import { NGXLogger } from 'ngx-logger';

export class LogRocketErrorHandler implements ErrorHandler {
  constructor(private ngxLogger: NGXLogger) {}
  public handleError(error) {
    this.ngxLogger.error(error);
    if (error instanceof Error) {
      if (LogRocket) {
        LogRocket.captureException(error);
      }
    }
  }
}
